<template>
  <div>
    <TitlePage :title="$t('edit')"></TitlePage>
    <v-layout wrap>
      <v-flex md4 class="pl-4 pr-4">
        <v-text-field :label="$t('name')" v-model="form.full_name" :rules="validation.textRules" :error-messages="errors.full_name"></v-text-field>
      </v-flex>
      <v-flex md4 class="pl-4 pr-4">
        <v-text-field :label="$t('email')" v-model="form.email"></v-text-field>
      </v-flex>
      <v-flex md4 class="pl-4 pr-4">
        <v-select label="Ruolo" v-model="form.role_id" :rules="validation.textRules"  :error-messages="errors.role" :items="roles"></v-select>
      </v-flex>
      <v-flex md4 class="pl-4 pr-4">
        <v-text-field :label="$t('password_new')" v-model="form.password_new"
                      :append-icon="showPassword2 ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword2 ? 'text' : 'password'"
                      @click:append="showPassword2 = !showPassword2" :error-messages="errors.password_new"
        ></v-text-field>
      </v-flex>
      <v-flex md4 class="pl-4 pr-4">
        <v-text-field :label="$t('password_new_confirm')" v-model="form.password_new_confirm"
                      :append-icon="showPassword3 ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword3 ? 'text' : 'password'"
                      @click:append="showPassword3 = !showPassword3" :rules="validation.passwordMatch" :error-messages="errors.password_new_confirm"
        ></v-text-field>
      </v-flex>
      <v-flex md4 class="pl-4 pr-4">
        <v-switch v-model="form.active" inset :label="$t('status')"></v-switch>
      </v-flex>
      <v-flex md12 class="pt-10 d-flex">
        <v-divider class="marg-title"></v-divider>
      </v-flex>
      <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
        <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
          <v-icon left>mdi-keyboard-backspace</v-icon>
          {{ $t('back') }}
        </v-btn>
        <v-btn elevation="2" color="primary" class="ml-auto" @click="update" type="submit">
          {{ $t('save') }}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-flex>

    </v-layout>
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import CenterAutocomplete from "@/components/admin/CenterAutocomplete";

export default {
  name: "EditCollaborator",
  components: {CenterAutocomplete, TitlePage},
  data() {
    return {
      check: true,
      showPassword2:false,
      showPassword3:false,
      roles: [],
      form:{
        active: false,
        full_name: '',
        email: '',
        password_new: '',
        password_new_confirm: '',
        center_id: '',
        role_id: '',
      },
      center_name: null,
      centers: null,
      errors:{
        full_name: '',
        password_new: '',
        password_new_confirm: '',
        role_id: '',
      },
      validation: {
        textRules: [
          v => !!v || this.$t('fillMandatory'),
        ],
        passwordMatch:[
          v => v == this.form.password_new || this.$t('password_not_match')
        ]
      }
    };
  },
  computed:{
    ...mapGetters({
      'getUser':'user/getUser',
      'getRoles':'permissions/getRoles',
    })
  },
  async created(){
    this.setLoading(true);

    var fetchItem = await this.editItem(this.$route.params)

    this.roles = this.getRoles()

    this.form.full_name = fetchItem.result.full_name;
    this.form.email = fetchItem.result.email;
    this.form.active = fetchItem.result.active;
    this.form.role_id = fetchItem.result.role_id;
    this.form.center_id = fetchItem.result.center_id;

    this.setLoading(false);
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'editItem':'centerAdmin/centerAdminEdit',
      'updateItem':'centerAdmin/centerAdminUpdate',
    }),

    async update(){

      await this.checkItem()
      if(!this.check){
        return
      }else {
        await this.resetError()
      }

      await this.setLoading(true);
      var result = await this.updateItem({...this.$route.params, item:this.form})
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }


    },

    async checkItem(){

      this.check = true

      if(!this.form.full_name){
        this.check = false
        this.errors.full_name = this.$t('fillMandatory');
      }

      if(this.form.password_new != '' || this.form.password_new_confirm != ''){

        if(!this.form.password_new){
          this.check = false
          this.errors.password_new = this.$t('fillMandatory');
        }

        if(!this.form.password_new_confirm){
          this.check = false
          this.errors.password_new_confirm = this.$t('fillMandatory');
        }

        if(this.form.password_new != this.form.password_new_confirm){
          this.check = false
          this.errors.password_new_confirm = this.$t('password_not_match');
        }

        if(!this.form.role_id){
          this.check = false
          this.errors.role_id = this.$t('fillMandatory');
        }

      }

    },
    async resetError(){
      this.errors = {
        full_name: '',
        password_new: '',
        password_new_confirm: '',
        role_id: '',
      }
    },

    setCenterId(id){
      this.form.center_id = id
    }

  },
  mounted() {

  },
}
</script>

<style scoped>

</style>